import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'premium-keys',
  templateUrl: './premium-keys.component.html',
  // standalone: true,
  // imports: [CommonModule],
})
export class PremiumKeysComponent implements OnInit, OnDestroy {
  @Input() currentUser;
  @Input() setupInstructions = [];
  @Input() title = [];
  @Output() premiumKeysEmitter = new EventEmitter();
  @Input() isActiveView: 'about' | 'premium-keys' = 'premium-keys';
  constructor() {}

  ngOnInit(): void {
    this.setupInstructions = [
      {
        title: 'What is a Premium Key?',
        list: [
          // `<p class="font-normal">Premium keys can be used to add an additional layer of encryption to electronic data in Kinnect.</p>`,
          '<p class="font-normal">Premium keys can be used to <span class="font-bold text-k-black"> create an additional layer of encryption </span> to electronic files in Kinnect.</p>',
          '<p class="font-normal">Premium keys can be <span class="font-bold text-k-black"> assigned to individual templates </span> at your discretion.</p>',
        ],
      },
      {
        title: 'What risks are associated with Premium Keys?',
        list: [
          '<p class="font-normal">There are no internal records or logs of User-Created Premium Keys inside of Kinnect. This means that <span class="font-bold text-k-black"> if a user loses or forgets their Premium Key, it will not be recoverable. <span></p>',
          '<p class="font-normal">There are certain failsafe mechanisms that can help decrease this risk, such as hints, and the ability to download a PDF of Premium Key information during the instance when one is initially created.</p>',
        ],
      },
      {
        title: 'Where can I manage Premium Keys in the future?',
        list: ['<p class="font-normal">You can manage Premium Keys from <span class="font-bold text-k-black"> Vaults > Encryption Keys. </span></p>'],
      },
      {
        title: 'How do I assign a Premium Key to a template?',
        list: [
          '<p class="font-normal">When you are adding or editing a template, there is a clearly marked area where you can select any existing premium keys to assign to the template.</p>',
        ],
      },
    ];
  }
  setActiveView(view: 'about' | 'premium-keys') {
    this.isActiveView = view;
    this.premiumKeysEmitter.emit(view);
  }
  ngOnDestroy(): void {}
}
